import "./entity-form.css"
import { InputText } from "@/components/input-text";
import { Button } from "@/components/button";
import type { Column } from "@/types/array.types";
import { useEffect, useState } from "react";
import { validateForm } from "@/utils/form";
import { InputDate } from "@/components/input-date";
import { Dropdown } from "@/components/dropdown";
import InputUpload from "@/components/input-upload/InputUpload";
import { onUploadPhoto } from "../../view-model/viewModel";
import { Icon } from "@/components/icon/Icon";


interface EntityFormProps<T> {
    columns: Column<T>[];
    entity?: T | null;
    table?: string;
    onCancel?: () => void;
    onDelete?: () => void;
    onSubmit?: (value: T) => void;
    onUpdate?: (value: Partial<T>) => void;
}

export function EntityForm<T extends Record<string, any>>({
    columns, 
    entity, 
    table, 
    onCancel, 
    onDelete,
    onSubmit, 
    onUpdate}: EntityFormProps<T>) {
  
    const [errors, setErrors] = useState<Partial<Record<keyof T, string>>>({});
    const [atBank, setAtBank] = useState(false);
    const [atMonaco, setAtMonaco] = useState(false);
    const [values, setValues] = useState<Partial<T>>({} as T)

    useEffect(() => {
        if (!entity) return;
        setValues(entity ?? {});
        setAtBank(Boolean(entity.at_bank));
        setAtMonaco(Boolean(entity.at_monaco));
      }, [entity]);

    const formatDateForInput = (value?: string | Date) => {
        if (!value) return "";
      
        const date = new Date(value);
      
        return date.toISOString().split("T")[0];
      };

    const isEdit = !!entity;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        const values = {};
        const photo = formData.get("photo");

        columns.map((column) => {
            if (!!formData.get(column.key as string) && column.key != "id"){
                values[column.key as string] = formData.get(column.key as string)
                }
                
            table == "jewelry" && (values["at_bank"] = atBank);
            table == "jewelry" && (values["at_monaco"] = atMonaco);  
            }
        )
        const validationErrors = validateForm(values, columns);
    
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return
        }
        setErrors({})

        if (photo instanceof File && photo.size > 0) {
            const response = await onUploadPhoto(photo);
            values["document_id"] = response.document.id;
          }

        if (isEdit) {
            onUpdate(values);
        }
        else {
            onSubmit(values as T);
        }
    }
    
    return  <form onSubmit={handleSubmit}  className="form-entity">
        {columns.map((column) => 
            {if(column.key != "id") {
                if (column.key == "document_id") {
                    return  <InputUpload 
                    entityId={entity?.id}
                    key={column.key as string} 
                    label={"Télécharger une photo"} 
                    name="photo" 
                    value={entity?.["imageUrl"] ? entity?.["imageUrl"] : null}/>
                }
                else if((column.key == "creation_date" || column.key == "date")) {
                    return  <InputDate
                    className={!isEdit && "new-input-date"}
                    error={errors[column.key]} 
                    key={column.key as string} 
                    label={column.label} name={column.key as string} 
                    defaultValue={isEdit ? formatDateForInput(entity?.[column.key as keyof T]) : ""}
                    /> 
                }
                else if (column.key == "at_monaco") {
                    return <Dropdown 
                    key="at_monaco"
                    inputLabel={"Monaco"}
                    label={atMonaco ? "Oui" : "Non"}  
                    options={[true, false]}
                    value={String(atMonaco)}
                    onChange={(value) => 
                        setAtMonaco(value === "Oui")}
                    renderLabel={(value) => value ? "Oui" : "Non"}/>
                }

                else if (column.key == "at_bank") {
                    return <Dropdown 
                    key="at_bank"
                    inputLabel={"Banque"}
                    label={atBank ? "Oui" : "Non"}
                    options={[true, false]}
                    value={String(atBank)}
                    onChange={(value) => setAtBank(value === "Oui")}
                    renderLabel={(value) => value ? "Oui" : "Non"}/>
                }

                else {
                    return <InputText 
                    error={errors[column.key]} 
                    key={column.key as string} 
                    label={column.label} 
                    name={column.key as string} 
                    value={String(values[column.key] ?? "")}
                    onChange={(e) =>
                      setValues((prev) => ({
                        ...prev,
                        [column.key]: e.target.value,
                      }))
                    }
                    placeholder={column.label}
                    />
                }
            }
        })}
        <button
            type="button"
            className="delete-action"
            onClick={onDelete}
        >
            <Icon name="delete" size="small" />
            Supprimer cette œuvre
        </button>
        <footer className="form-footer">
            <Button className="button-cancel" label="Annuler" onClick={onCancel} variant="secondary"></Button>
            <Button className="button-submit" label={isEdit ? "Envoyer" : "Créer"} type="submit"></Button>
        </footer>
    </form>    
}